import * as React from 'react';
import { HasQuizResultsContext, QuizResultsContext } from '@mentimeter/quiz';
import {
  useHasQuizResults,
  useQuizPlayersScore,
  useQuizResult,
} from '@mentimeter/core-hooks';
import { isTypeQuizSlide } from 'features/core/shared/questionFilters';
import type { Question } from '@mentimeter/http-clients';

export const QuizResultProvider = ({
  type,
  questionId,
  children,
  isTestVotesEnabled,
  setQuizResultsHasLoadedForScreenshot,
}: {
  type: Question['type'];
  questionId: string;
  children: React.ReactNode;
  isTestVotesEnabled: boolean;
  setQuizResultsHasLoadedForScreenshot?: (value: boolean) => void;
}) => {
  const shouldFetch = isTypeQuizSlide(type) && !isTestVotesEnabled;

  const playerScores = useQuizPlayersScore({
    questionId,
    shouldFetch: shouldFetch && type !== 'quiz',
  });
  const quizResult = useQuizResult({
    questionId,
    shouldFetch: shouldFetch && type === 'quiz',
  });
  const results = type === 'quiz' ? quizResult : playerScores;

  const hasQuizResults = useHasQuizResults({
    questionId,
    questionType: type,
    shouldFetch,
  });

  React.useEffect(() => {
    if (
      setQuizResultsHasLoadedForScreenshot &&
      shouldFetch &&
      !results.isLoading
    ) {
      setQuizResultsHasLoadedForScreenshot(true);
    }
  }, [shouldFetch, results.isLoading, setQuizResultsHasLoadedForScreenshot]);

  return (
    <QuizResultsContext.Provider value={results}>
      <HasQuizResultsContext.Provider value={hasQuizResults}>
        {children}
      </HasQuizResultsContext.Provider>
    </QuizResultsContext.Provider>
  );
};
